import React from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "../../../icons/Globe2";
import { List } from "../../../icons/List";


export const ViewButton = ({ variant, className,url }) => {

  return (
    <Link
      className={`w-[136px] flex items-center gap-1.5 p-4 [-webkit-backdrop-filter:blur(32px)_brightness(100%)] rounded-[40px] justify-center bg-[#000000e0] backdrop-blur-[32px] backdrop-brightness-[100%] relative ${className}`}
      to={url}
    >
      {variant === "map" && <Globe2 className="!relative !w-5 !h-5" />}

      {variant === "list" && <List className="!relative !w-5 !h-5" />}

      <div className="font-secondary w-fit tracking-[-0.32px] text-sm text-wwwstanfordcourtcomwhite font-normal leading-[normal] relative">
        {variant === "map" && <>Map</>}

        {variant === "list" && <>List</>}
      </div>
    </Link>
  );
};